/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TemplateFieldValue
 */
export interface TemplateFieldValue {
    /**
     * 
     * @type {string}
     * @memberof TemplateFieldValue
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateFieldValue
     */
    value?: string;
}

/**
 * Check if a given object implements the TemplateFieldValue interface.
 */
export function instanceOfTemplateFieldValue(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TemplateFieldValueFromJSON(json: any): TemplateFieldValue {
    return TemplateFieldValueFromJSONTyped(json, false);
}

export function TemplateFieldValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): TemplateFieldValue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function TemplateFieldValueToJSON(value?: TemplateFieldValue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'value': value.value,
    };
}

